import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '4all-ui/components/Checkbox';
import Switch from '4all-ui/components/Switch';
import ProductImage from '4all-ui/components/ProductImage';
import { styles } from '4all-ui/styles';
import { connect } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import equals from '../../../../helpers/equals';
import { priceToInt, formatPrice, formatPriceOnKeyPress } from '../../../../helpers/price';
import {
  PRODUCT_ACTIONS_TYPE,
  ENTITIES,
  PRODUCT_STATUS,
  PRODUCT_CORE_ACTIONS,
  PRODUCT_ELEMENT_ID_PREFIX,
} from '../../../../helpers/constants';
import * as style from './style';
import { ActionBtn, InputSave } from '../../../../components';
import env from '../../../../config/env';
import { getDraggableStyle } from '../../style';

class ProductItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      originalPrice: 0,
      defaultPrice: 0,
      isOpenBtnPrice: false,
    };

    this.ref = null;
  }

  componentDidMount() {
    this.setState({
      defaultPrice: this.props.originalPrice,
      originalPrice: this.props.originalPrice,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.originalPrice !== this.props.originalPrice) {
      this.setState({
        originalPrice: nextProps.originalPrice,
        defaultPrice: nextProps.originalPrice,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      equals(this.props.product, nextProps.product) &&
      equals(this.state, nextState) &&
      nextProps.isProductDragDisabled === this.props.isProductDragDisabled
    ) {
      return false;
    }
    return true;
  }

  onChangePrice = (e, value) => {
    this.setState({
      [e.target.name]: value,
    });
  };

  productIsOnMenu = (categoryId, productId) =>
    this.props.menus.some(menu =>
      menu.categories.some(
        cat => cat.id === categoryId && cat.products.some(prod => prod.id === productId)
      )
    );

  changeProductStatus = (checked, productId) => {
    if (this.productIsOnMenu(this.props.categoryId, productId) && !checked) {
      this.props.productAction(PRODUCT_CORE_ACTIONS.CHANGE_STATUS, {
        productId,
        categoryId: this.props.categoryId,
      });
    } else {
      this.props.callbackStatus(checked, productId);
    }
  };

  onClick = type => {
    const product = {
      id: this.props.id,
      name: this.props.name,
      categoryId: this.props.categoryId,
    };

    if (type === PRODUCT_CORE_ACTIONS.DELETE) {
      this.props.productAction(PRODUCT_CORE_ACTIONS.DELETE, product);
    } else if (type === PRODUCT_CORE_ACTIONS.EDIT) {
      this.props.onClickProductActions(type, product.id);
    }
  };

  onFocusPrice = () => {
    this.setState({
      isOpenBtnPrice: true,
      originalPrice: this.state.originalPrice,
    });
  };

  onBlurPrice = () => {
    this.setState({
      isOpenBtnPrice: false,
      originalPrice: this.props.originalPrice,
    });
  };

  setNewPrice = async e => {
    e.preventDefault();
    if (priceToInt(this.state.originalPrice) !== this.props.product.originalPrice) {
      const data = {
        ...this.props.product,
        categories: this.props.categories.filter(item => item.id === this.props.categoryId),
        originalPrice: priceToInt(this.state.originalPrice),
      };

      await this.props.editProduct(this.props.id, data);
    }
    this.setState({
      defaultPrice: this.state.originalPrice,
      isOpenBtnPrice: false,
    });
  };

  onClickRow = event => {
    if (event.defaultPrevented) {
      return;
    }

    this.ref.focus();
  };

  render() {
    const { id, name, image, status, checked, index, isProductDragDisabled } = this.props;
    const draggableId = `${ENTITIES.PRODUCT}_${id}`;
    return (
      <Draggable draggableId={draggableId} index={index} isDragDisabled={!!isProductDragDisabled}>
        {(provided, snapshot) => (
          <style.RowProduct
            id={`${PRODUCT_ELEMENT_ID_PREFIX}${id}`}
            ref={ref => {
              this.ref = ref;

              return provided.innerRef(ref);
            }}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            style={getDraggableStyle(provided.draggableProps.style, snapshot)}
            onClick={this.onClickRow}
          >
            <style.ProductDetails isDragging={snapshot.isDragging}>
              <Checkbox
                id={`checkbox_${id}`}
                name={name}
                checked={checked}
                disabled={status === PRODUCT_STATUS.INACTIVE}
                onChange={() =>
                  this.props.toggleListProductItem(this.props.categoryId, this.props.id)
                }
              />

              <ProductImage
                size="52px"
                image={image.imageUrl && `${env.REACT_APP_BASE_IMG}${image.imageUrl}`}
                customStyles={{
                  border: `1px solid ${styles.colors.GRAY_LIGHT_2}`,
                }}
              />

              <style.ProductName id={`product_name_${id}`} disabled={status !== 1}>
                {name}
              </style.ProductName>
            </style.ProductDetails>
            <style.ProductActions isDragging={snapshot.isDragging}>
              <InputSave
                id={`product_price_${id}`}
                name="originalPrice"
                value={formatPrice(priceToInt(this.state.originalPrice) / 100)}
                btnLabel="Salvar"
                onChange={this.onChangePrice}
                onSave={this.setNewPrice}
                onFocus={this.onFocusPrice}
                onBlur={this.onBlurPrice}
                isBtnOpen={this.state.isOpenBtnPrice}
              />

              <Switch
                id={`switch_status_product_${id}`}
                checked={status === PRODUCT_STATUS.ACTIVE}
                onChange={e => this.changeProductStatus(e.target.checked ? 1 : 0, id)}
                labelStyles={{
                  marginLeft: 0,
                }}
              />

              <ActionBtn
                id={`actionbtn_${id}`}
                items={PRODUCT_ACTIONS_TYPE}
                onClick={this.onClick}
              />
            </style.ProductActions>
          </style.RowProduct>
        )}
      </Draggable>
    );
  }
}

ProductItem.propTypes = {
  categoryId: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  originalPrice: PropTypes.number.isRequired,
  image: PropTypes.object,
  status: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  callbackStatus: PropTypes.func,
  index: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  menus: state.menu.menus,
});

export default connect(mapStateToProps)(ProductItem);



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/ProductItem/index.js